import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from '../../services/master-data.service';

@Component({
  selector: 'app-know-your-colleauges',
  templateUrl: './know-your-colleauges.component.html',
  styleUrls: ['./know-your-colleauges.component.css']
})
export class KnowYourColleaugesComponent implements OnInit {

  userNameList;
  selectName;
  user;
  userPhoto;
  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectName = ""
    this.getUserList();
  }

  getUserList() {
    this.masterDataService.getUserDetails().subscribe((resp: any) => {
      console.log('user details', resp);
      this.userNameList = resp;
    })
  }

  getColleaugeDetails() {
    this.user = undefined;
    this.userPhoto = undefined;
    if (this.selectName == "" || this.selectName == undefined || this.selectName == null) {
    this.commonMessageService.swalAlertWithoutIcon('','Please select employee name')
    } else {
      this.masterDataService.getUserProfileByIdForDecleration(this.selectName.userId).subscribe((resp: any) => {
        console.log('report details', resp);
        this.user = resp;
      });

      this.masterDataService.getProfilePhotoForColleaugeDetails(this.selectName.userId).subscribe((resp: any) => {
        console.log('user photo details', resp);
        this.userPhoto = resp;
      });
    }
  }
}
